import React, { useState, useContext, useEffect } from 'react'
import io from 'socket.io-client';
import axios from 'axios'
import { useLocation, useNavigate } from 'react-router-dom';
import Editing1 from './images/MenuReg/Editing1.png'
import { DBContext } from './DBContext'
import Search from './images/MenuReg/search1.png'
import { toast } from 'react-toastify';
import remove from './images/Inventory/delete.png'

function TaxGroup() {

    const api_base_url = process.env.REACT_APP_API_BASE_URL

    const { customerCode, logginedDB } = useContext(DBContext);
    const [search, setSearch] = useState("");

    const location = useLocation();

    const navigate = useNavigate();

    const [taxGroups, setTaxGroups] = useState([]);

    const handGetTaxGroups = async () => {
        try {
            const response = await fetch(`${api_base_url}/getTaxGroups/${logginedDB}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = await response.json();
            console.log("data", data);

            setTaxGroups(data);

        } catch (error) {
            console.error('Error fetching items:', error);
        }
    };

    //("taxGroups", taxGroups);

    const filteterTxGroup = taxGroups.filter((item) =>
        item?.name?.toLowerCase().includes(search.toLowerCase())
    );


    useEffect(() => {
        handGetTaxGroups()
    }, [api_base_url]);

    const handleAddTax = () => {
        navigate('/AddTax')
    }

    const [selectedTax, setSelectedTax] = useState([])

    const [isCheckedAllTax, setIsCheckedAllTax] = useState(false);

    const [checkedTax, setCheckedTax] = useState(
        taxGroups.map(() => false) // Initialize all as unchecked
    );

    const handleIsCheckedAll = (e) => {
        const checked = e.target.checked;
        setIsCheckedAllTax(checked);
        setCheckedTax(taxGroups.map(() => checked)); // Set all checkboxes to the same state

        // Update selectedUsers with all or none
        if (checked) {
            setSelectedTax(taxGroups.map((area) => area.id_tax)); // Add all user ids
        } else {
            setSelectedTax([]); // Clear selection
        }
    };

    // Handle individual checkboxes
    const handleIsChecked = (index, checked) => {
        const updatedChecked = [...checkedTax];
        updatedChecked[index] = checked;
        setCheckedTax(updatedChecked);

        // Update "Select All" state if not all items are selected
        const allChecked = updatedChecked.every((item) => item);
        setIsCheckedAllTax(allChecked);

        // Update selectedUsers based on checked state
        const updatedSelectedUsers = [...selectedTax];
        const userId = taxGroups[index].id_tax;

        if (checked) {
            // Add the user id if checked
            updatedSelectedUsers.push(userId);
        } else {
            // Remove the user id if unchecked
            const userIndex = updatedSelectedUsers.indexOf(userId);
            if (userIndex !== -1) {
                updatedSelectedUsers.splice(userIndex, 1);
            }
        }

        setSelectedTax(updatedSelectedUsers);
    };

    function formatISODateToDDMMYYYY(isoDateString) {
        const date = new Date(isoDateString); // Convert ISO string to Date object
        const dd = String(date.getDate()).padStart(2, '0'); // Day with leading zero
        const mm = String(date.getMonth() + 1).padStart(2, '0'); // Month with leading zero
        const yyyy = date.getFullYear(); // Year
        return `${dd}-${mm}-${yyyy}`;
    }

    const handleToDeleteTaxGroup = async () => {
        if (selectedTax.length > 0) {
            const userConfirmed = window.confirm(`Delete selected tax group?`);

            if (!userConfirmed) {
                return;
            }
            try {
                const response = await axios.post(`${api_base_url}/deleteTaxGroup/${logginedDB}`, selectedTax)
                if (response.status === 200) {
                    toast.success(`Successfully deleted!`, {
                        className: 'custom-toast',
                        bodyClassName: 'custom-toast-container',
                        closeButtonClassName: 'custom-toast-close-button',
                        onClose: () => { }
                    });
                    handGetTaxGroups()
                    setCheckedTax(taxGroups.map(() => false))
                    setIsCheckedAllTax(false)
                }
            } catch (error) {
                //(error);
            }
        } else {
            alert('Select any sub kitchen!')
        }
    }

    return (
        <div className='h-full flex flex-col overflow-hidden'>
            <div className='h-full flex flex-col bg-[#fff] overflow-hidden'>
                <div className='w-full h-max flex p-3 '>
                    {taxGroups.length > 0 ? (
                            <div className='w-1/2'>
                                <div className='w-1/2 flex border border-[#ccc] rounded-[.313rem]'>
                                    <div className='flex justify-center items-center p-2'>
                                        <img className='w-[1rem]' src={Search} alt="?" />
                                    </div>
                                    <input className='w-full pr-2 border-none' onChange={(e) => setSearch(e.target.value)} type="text" placeholder='Search...' />
                                </div>
                            </div>
                        ) : (
                            <div className='w-1/2 font-nunito flex justify-start items-center'>Tax not registered yet.</div>
                        )
                    }
                    <div className='w-1/2 flex justify-end items-center font-nunito text-[1rem]'>
                        <button className='bg-[#0008B4] text-[#fff] font-[600] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3 focus:outline-none' onClick={handleAddTax}>Add Tax Group</button>
                    </div>
                </div>
                <div className='relative flex flex-col w-full h-full text-center font-nunito text-[1rem] rounded-[.313rem] overflow-auto noScroll'>
                    <div className='sticky top-0 w-full min-h-max flex font-[600] rounded-tl-[.313rem] bg-[#E5E5E5] text-nowrap z-[7777]'>
                        <div className='sticky left-0 bg-[#E5E5E5] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[6666]'>
                            <input type="checkbox"
                                checked={isCheckedAllTax}
                                onChange={(e) => handleIsCheckedAll(e)}
                            />
                        </div>
                        <div className='w-8/12 p-3 bg-[#E5E5E5] text-left'>Name</div>
                        <div className='w-8/12 p-3 bg-[#E5E5E5] text-left hidden'>Schedule</div>
                        <div className='w-8/12 p-3 bg-[#E5E5E5]'>Gst</div>
                        <div className='w-8/12 p-3 bg-[#E5E5E5]'>SDate</div>
                        <div className='w-8/12 p-3 bg-[#E5E5E5]'>EDate</div>
                        <div className='w-8/12 p-3 bg-[#E5E5E5]'>CGST</div>
                        <div className='w-8/12 p-3 bg-[#E5E5E5]'>SGST</div>
                        {/* <div className='w-8/12 p-3 bg-[#E5E5E5]'>IGST</div> */}
                        <div className='w-8/12 p-3 bg-[#E5E5E5] hidden'>FCESS</div>
                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#E5E5E5] z-[6666]'>Action</div>
                    </div>
                    <div className='flex flex-col w-full z-[6666] text-wrap'>
                        {filteterTxGroup?.map((tax, index) => (
                            <div className='flex w-full text-nowrap'>
                                <div className='sticky left-0 bg-[#fff] rounded-tl-[.313rem] min-w-[3rem] max-w-[3rem] flex justify-center items-center p-3 z-[6666]'>
                                    <input type="checkbox"
                                        checked={checkedTax[index]}
                                        onChange={(e) =>
                                            handleIsChecked(index, e.target.checked)
                                        }
                                    />
                                </div>
                                <div className='w-8/12 p-3 text-wrap text-left'>{tax.name}</div>
                                <div className='w-8/12 p-3 text-left hidden'>{tax.Schedule}</div>
                                <div className='w-8/12 p-3'>{tax.gstPercent}</div>
                                <div className='w-8/12 p-3'>{tax.sdate ? formatISODateToDDMMYYYY(tax.sdate) : '-'}</div>
                                <div className='w-8/12 p-3'>{tax.edate ? formatISODateToDDMMYYYY(tax.edate) : '-'}</div>
                                <div className='w-8/12 p-3'>{tax.cgst}</div>
                                <div className='w-8/12 p-3'>{tax.sgst}</div>
                                {/* <div className='w-8/12 p-3'>{tax.igst}</div> */}
                                <div className='w-8/12 p-3 hidden'>{tax.fcess}</div>
                                {/* <div className='min-w-[7rem] max-w-[7rem] p-3 flex justify-center items-center relative'>
                                <input
                                    type="checkbox"
                                    id="active_inactive_checkbox"
                                    // checked={isActiveCategory[Category.id_category] || false} 
                                    readOnly 
                                />
                                <div
                                    className='active_inactive_div'
                                    // onClick={() => handleIsActiveCategory(Category.id_category,Category.Status)}
                                ></div>
                            </div> */}
                                {
                                    checkedTax[index] ? (
                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                            <img className='w-[1rem] cursor-pointer' src={remove} alt="" onClick={handleToDeleteTaxGroup} />
                                        </div>
                                    ) : (
                                        <div className='sticky right-0 min-w-[7rem] max-w-[7rem] p-3 rounded-tr-[.313rem] bg-[#fff] z-[6666] flex justify-center items-center gap-2'>
                                            {/* <img className='w-[1rem] opacity-75 cursor-pointer' src={Redeye1} alt="" onClick={() => handleToView(Category)}/> */}
                                            <img className='w-[1rem] cursor-pointer' src={Editing1} alt="" onClick={() => navigate('/EditTax    ', {
                                                state: {
                                                    id: tax.id_tax,
                                                    tax: tax.name
                                                }
                                            })} />
                                        </div>
                                    )
                                }
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TaxGroup
